import ProcessRegistrationPopup from './ProcessRegistrationPopup';

export default {
    ProcessRegistrationPopup,
};

export {
    ProcessRegistrationPopup,
};